import { combineReducers } from 'redux';
import { FAILED_TO_SUBMIT_CORPORATE_INSTITUTION_FAILED, SUBMITTED_CORPORATE_INSTITUTION_TYPE, SUBMITTING_CORPORATE_INSTITUTION_TYPE } from '../actions/financial-institution';
const initialState = {
  submitted: false,
  submitting: false,
  error: false
};
export const submitCorporateInstitution = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SUBMITTED_CORPORATE_INSTITUTION_TYPE:
      return {
        submitted: true,
        submitting: false,
        error: false
      };
    case FAILED_TO_SUBMIT_CORPORATE_INSTITUTION_FAILED:
      return {
        submitted: false,
        submitting: false,
        error: true
      };
    case SUBMITTING_CORPORATE_INSTITUTION_TYPE:
      return {
        submitted: false,
        submitting: true,
        error: false
      };
    default:
      return state;
  }
};
export default combineReducers({
  submitCorporateInstitution
});